export enum OrderExceptionCode {
  PGSIssue,
  MagentoOrderCreationIssue,
}

export type PGSException = {
  code: OrderExceptionCode.PGSIssue;
};

export type MagentoOrderCreationIssueException = {
  message?: string;
  code: OrderExceptionCode.MagentoOrderCreationIssue;
};

export type OrderException = PGSException | MagentoOrderCreationIssueException;

export type CheckoutError = {
  visible: boolean;
  exception: OrderException | null;
};
